import { render } from "./ReportIssue.vue?vue&type=template&id=5e59a48a&scoped=true"
import script from "./ReportIssue.vue?vue&type=script&lang=js"
export * from "./ReportIssue.vue?vue&type=script&lang=js"

import "./ReportIssue.vue?vue&type=style&index=0&id=5e59a48a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e59a48a"]])

export default __exports__